'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var More = function More(_ref) {
  var color = _ref.color,
      title = _ref.title,
      className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-more ' + className, width: width, height: height, viewBox: '0 0 16 16', version: '1.1' },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', { fill: color, d: 'M6 1h4v4h-4zM6 6h4v4h-4zM6 11h4v4h-4z' })
  );
};

More.propTypes = _.IconPropTypes;

exports.default = More;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/More/More.js
// module id = 119
// module chunks = 0 1 2 3 4 5 6 7 8 9